import React from 'react';
import { string, bool, func } from 'prop-types';
import cameraIcon from '../../images/ico-camera-2x.png';

/**
 * ProfileHeader.
 * @returns {React.component} The profile header to render.
 */
const ProfileHeader = (props) => {
  const {
    imageUrl, name, actingUserCanEdit, updateActiveView, aboutMe, profileVisibility, isAdmin,
  } = props;
  return (
    <header className="profile-header">
      <img className="profile-avatar" src={imageUrl} alt={name} />
      {actingUserCanEdit &&
        <button onClick={updateActiveView} className="avatar-button" name="avatar">
          <img className="avatar-button__image" src={cameraIcon} alt="" />
        </button>
      }
      <h1>{name}</h1>
      <p className="contain">
        {(actingUserCanEdit || profileVisibility === 'PUBLIC' || isAdmin) &&
          aboutMe
        }
      </p>
    </header>
  );
};

/**
 * Validation on passed-in props.
 * @type {Object}
 */
ProfileHeader.propTypes = {
  name: string,
  imageUrl: string,
  aboutMe: string,
  actingUserCanEdit: bool,
  setActiveView: func,
  profileVisibility: string,
};

export default ProfileHeader;



// WEBPACK FOOTER //
// ./src/components/ProfileHeader/ProfileHeader.js